import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { specializationClient } from '../client/specializationClient';


export type Params = {
  id: number;
};

type Options = {

};

const defaultOptions: Partial<Options> = {
};

export const useSpecialization = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: specialization } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getSpecialization, params.id],
    queryFn: () => specializationClient.getSpecialization(params),
  });

  return {
    ...rest,
    specialization,
  };
};
